import React from "react";
import moment from "moment";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import BarcodeReader from "react-barcode-reader";

import TextArea from 'antd/lib/input/TextArea';
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox,
} from "antd";
import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
  GREATER_THAN_ZERO
} from "../../../common/types/regularExpresionType";
import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  PORCENTAJE_PERCEPCION
} from "../../../common/types/parametroType";

import {
  FACTURA,
  BOLETA_DE_VENTA,
  NOTA_DE_CREDITO,
  NOTA_DE_DEBITO,
} from "../../../common/types/tipoComprobanteType";
import { CONTADO, CREDITO } from "../../../common/types/formaPagoType";

import { SOLES } from "../../../common/types/monedaType";
import dialog from "../../../common/utility/dialog";

import Footer from "./FormModal/Footer";
import Productos from "./FormModal/Productos";
import Referencias from "./FormModal/Referencias";

import MetodoPago from "./FormModal/MetodoPago";
import Cuotas from "./FormModal/Cuotas";
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      result: "No result",
    };
    this.handleScan = this.handleScan.bind(this);

  }


  handleScan(data) {
    debugger;
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue,
      this.handleCalculateDetail
    );
  }

  handleError(err) {
    alert("error");
    console.error(err);
  }


  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  findDaysAndDates = (property, value) => {
    if (property === "diasVencimiento") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const diasVencimiento = parseInt(value);
      this.props.form.setFieldsValue({
        fechaVencimientoStr: fecha.add("days", diasVencimiento),
      });
    }

    if (property === "fechaVencimientoStr") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const fechaVencimiento = moment(value, "DD/MM/YYYY");
      this.props.form.setFieldsValue({
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  completeDocumento = (e) => {
    var value = e.target.value;
    if (value.length === 0) return;

    var zeros = "";
    for (let index = 0; index < 8 - value.length; index++) {
      zeros += "0";
    }
    this.props.form.setFieldsValue({ documento: zeros + value }, () => {
      this.props.form.validateFields(["documento"], { force: true });
    });
  };

  documentoCustomValidation = (rule, value, callback) => {
    if (value === "00000000") callback("Documento no válido");

    callback();
  };


  handleSearchAutocompleteProveedor = async (value) => {
    const result = this.props.formValues.proveedores
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ proveedores: result });
  };

  handleChangeAutocompleteProveedor = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoProveedor: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idProveedor",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart >= dateEnd) {
      return 0;
    }
    return 1;
  }

  handleCalculateDetail = (row, property, value, numberDecimals) => {

    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    /********* Datos de parametro ******/
    var centaje = 0;
    var otroImpuesto = this.props.form.getFieldValue("otroImpuesto");
    var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === otroImpuesto?.key)?.value ?? 18;

    centaje = 1 + (porcentajeIGV / 100);

    var porcentajeISC = parseFloat(
      params.filter(
        (m) => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA
      )[0].valor
    );
    var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;


    /*********** Datos por fila ********/

    var flagAfecto = false;
    var flagExonerado = false;
    var flagGratuito = false;
    var flagISC = false;

    var flagChangeTotal = false;

    var getImpuesto =
      property === "arridImpuesto"
        ? value
        : this.props.form.getFieldValue(`arridImpuesto[${row.identifier}]`).key;


    const selectedImpuesto = this.props.formValues.tipoAfectacion.find(x => x.id === getImpuesto);

    const DEFAULT_CODIGO = '10';
    const codigo = selectedImpuesto?.codigoSunat ?? DEFAULT_CODIGO;

    switch (true) {

      // Gravado
      case ["10", "17"].includes(codigo):
        flagAfecto = true;
        break;

      // Exonerado
      case codigo === "20":
        flagExonerado = true;
        break;

      // Inafecto
      case codigo === "30":
        break;

      // Exportación
      case codigo === "40":
        break;
    }



    var porcentajeMargenComercial = this.fetchFieldValue(
      row.identifier,
      "arrPorcentajeMargenComercial"
    );

    var precioPromedio = this.fetchFieldValue(
      row.identifier,
      "arrPrecioPromedio"
    );

    var fechaVencimiento = property === "arrFechaVencimiento" ? value : this.props.form.getFieldValue(`arrFechaVencimiento[${row.identifier}]`);

    var numeroRegistroSanitario = property === "arrNumeroRegistroSanitario" ? value : this.props.form.getFieldValue(`arrNumeroRegistroSanitario[${row.identifier}]`);
    //var fechaProduccion = property === "arrFechaProduccion" ? value : this.props.form.getFieldValue(`arrFechaProduccion[${row.identifier}]`);

    const precioIncluyeIGV = this.props.form.getFieldValue("flagPrecioIncluyeIGV");

    let valorUnitario = this.fetchFieldValue(row.identifier, "arrValorUnitario");
    let precioUnitario = this.fetchFieldValue(row.identifier, "arrPrecioUnitario");

    const IGV = 1.18;

    // Si el precio incluye IGV
    if (precioIncluyeIGV) {
      precioUnitario = precioUnitario;

      valorUnitario = flagAfecto
        ? precioUnitario / IGV
        : precioUnitario;

    } else {
      valorUnitario = valorUnitario;

      precioUnitario = flagAfecto
        ? valorUnitario * IGV
        : valorUnitario;
    }

    var cantidad = parseFloat(
      property === "arrCantidad"
        ? value
        : this.fetchFieldValue(row.identifier, "arrCantidad"));
    // var cantidad = this.fetchFieldValue(row.identifier, "arrCantidad");
    var porcentajeDescuento = this.fetchFieldValue(row.identifier, "arrPorcentajeDescuento");
    var importeDescuento = this.fetchFieldValue(row.identifier, "arrImporteDescuento");
    var total = this.fetchFieldValue(row.identifier, "arrTotal");

    if (isNaN(parseFloat(importeDescuento)) || importeDescuento === "") {
      importeDescuento = 0;
    }

    if (isNaN(parseFloat(porcentajeDescuento)) || porcentajeDescuento === "") {
      porcentajeDescuento = 0;
    }
    if (porcentajeDescuento > 100) {
      message.warning("El porcentaje de descuento no puedo ser mayor a 100%");
      return;
    }

    /*********** Datos por fila (bloquear checks) ********/
    if (flagGratuito && property == "arrFlagGratuito") {
      flagAfecto = false;
      flagISC = false;
      flagExonerado = false;
    }

    if (flagAfecto && property == "arrFlagAfecto") {
      flagGratuito = false;
      flagExonerado = false;
      flagISC = false;
    }

    if (flagExonerado && property == "arrFlagExonerado") {
      flagAfecto = false;
      flagGratuito = false;
      flagISC = false;
    }

    /*********** Calculo precios unitarios ********/
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
    var precioUnitarioSinIGV = !flagAfecto ? precioUnitario : flagPrecioIncluyeIGV
      ? precioUnitario / divisorCalculoSubTotal
      : valorUnitario;

    /*********** Calculo por ISC ********/
    var importeISC = flagISC ? precioUnitarioSinIGV * (porcentajeISC / 100) : 0;
    var precioUnitarioISC = flagISC ? precioUnitarioSinIGV + importeISC : 0;
    var totalDetalle = flagISC
      ? cantidad * precioUnitarioISC
      : cantidad * precioUnitarioSinIGV;

    /*********** Calculo totales ********/
    var subTotal = totalDetalle;
    var igv = parseFloat(
      (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0)
    );
    total = parseFloat((subTotal + igv));

    if (property === "arrTotal" && parseFloat(newValue) !== total) {
      flagISC = false;
      importeISC = 0;
      precioUnitarioISC = 0;
      flagChangeTotal = true;

      /*********** Calculo totales ********/
      total = parseFloat(value);
      porcentajeDescuento = 0;
      importeDescuento = 0;
      subTotal = parseFloat(
        (flagAfecto ? total / (1 + porcentajeIGV / 100) : total)
      );

      /*********** Calculo por ISC ********/
      totalDetalle = flagISC ? cantidad * precioUnitarioISC : subTotal;

      /*********** Calculo Cantidad ********/
      cantidad = parseFloat((subTotal / precioUnitarioSinIGV).toFixed(3));
      if (cantidad === 0) cantidad = 1;

      /*********** Calculo IGV ********/
      igv = flagAfecto ? subTotal * (porcentajeIGV / 100) : 0;
    }

    /*********** Calculo descuentos ********/
    if (importeDescuento > 0 || porcentajeDescuento > 0) {
      var calculoimporteDescuento = 0;
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuento = parseFloat(
          (total * (porcentajeDescuento / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuento = parseFloat(
          (totalDetalle * (porcentajeDescuento / 100)).toFixed(2)
        );
      }

      if (
        importeDescuento !== calculoimporteDescuento &&
        property === "arrImporteDescuento"
      )
        porcentajeDescuento = 0;
      else importeDescuento = calculoimporteDescuento;

      if (flagPrecioIncluyeIGV) {
        total = total - importeDescuento;

        if (flagAfecto) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        subTotal = subTotal - importeDescuento;

        if (flagAfecto) {
          var igv = parseFloat(
            (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }
    }



    /*********** Calculo gratuito ********/
    if (flagGratuito) {
      porcentajeDescuento = 0;
      importeDescuento = 0;
      igv = 0;
      subTotal = 0;
      total = 0;
    }

    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });
    var dateVcto = row.flagVencimiento ? fechaVencimiento : null;

    detalleProductosFilter.push({
      identifier: row.identifier,
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      idProducto: row.idProducto,
      codigoBarra: row.codigoBarra,
      idTipoProducto: row.idTipoProducto,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario: precioUnitario,
      valorUnitario,
      igv,
      totalDetalle,
      listaCompraDetalleSerie: row.listaCompraDetalleSerie,
      flagAplicarSerie: row.flagAplicarSerie,
      numeroRegistroSanitario: numeroRegistroSanitario == undefined ? null : numeroRegistroSanitario,
      fechaVencimientoStr: (fechaVencimiento == null || fechaVencimiento == undefined) ? null : fechaVencimiento.format('DD/MM/YYYY'),
      flagVencimiento: row.flagVencimiento,
      fechaProduccionStr: null,// fechaProduccion == null ? null : fechaProduccion.format('DD/MM/YYYY'),
      porcentajeDescuento,
      importeDescuento,
      numeroLote: this.props.form.getFieldValue(`arrLote[${row.identifier}]`),
      flagAfecto,
      flagExonerado,
      flagISC,
      flagOtrosImpuesto: false, // OMITIDO POR EL MOMENTO
      idImpuesto: selectedImpuesto?.id ?? 1,
      flagGratuito,
      flagChangeTotal,
      total,
      subTotal
    });

    /*********** Re-Calcular Suma SubTotal ********/

    var sumaTotalAfecto = this.fetchSumaTotalAfecto(
      row.identifier,
      codigo,
      total
    );
    var sumaTotalInafecto = this.fetchSumaTotalInafecto(
      row.identifier,
      codigo,
      total
    );

    var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
      row.identifier,
      codigo,
      total
    );

    var fetchSumaTotalGratuito = this.fetchSumaTotalGratuito(
      row.identifier,
      codigo,
      total
    );

    var sumaTotalExportacion = this.fetchSumaTotalExportacion(
      row.identifier,
      codigo,
      total
    );

    /*********** Calculo suma detalle ********/
    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      importeDescuento
    );

    var sumaIsc = this.fetchFieldValueSum(
      row.identifier,
      "arrIsc",
      cantidad === 0 ? 0 : importeISC
    );
    var sumaTotal = parseFloat(this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2));
    var sumaSubTotal = parseFloat(
      (
        sumaTotalAfecto / divisorCalculoSubTotal +
        (sumaTotalInafecto + fetchSumaTotalExonerado + sumaTotalExportacion)
      ).toFixed(2)
    );

    var sumaIgv = (sumaTotal - fetchSumaTotalGratuito) - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** DECUENTOS GLOBALES ********/
    var tipoDocumento = this.props.form.getFieldValue("idTipoComprobante") == undefined ? 0 : this.props.form.getFieldValue("idTipoComprobante").key;

    if ([FACTURA.ID, BOLETA_DE_VENTA.ID].includes(tipoDocumento)) {

      var flagDescuentoGlobal = this.props.form.getFieldValue("flagDescuentoGlobal");

      if (flagDescuentoGlobal) {
        var importeDescuentoGlobal = this.props.form.getFieldValue("importeDescuentoGlobal");
        var porcentajeDescuentoGlobal = this.props.form.getFieldValue("porcentajeDescuentoGlobal");
        if (
          isNaN(parseFloat(importeDescuentoGlobal)) ||
          importeDescuentoGlobal === ""
        ) {
          importeDescuentoGlobal = 0;
        }
        if (
          isNaN(parseFloat(porcentajeDescuentoGlobal)) ||
          porcentajeDescuentoGlobal === ""
        ) {
          porcentajeDescuentoGlobal = 0;
        }

        if (importeDescuentoGlobal > 0) {
          if (flagPrecioIncluyeIGV) {
            if (importeDescuentoGlobal > sumaTotal) {
              importeDescuentoGlobal = 0;
              porcentajeDescuentoGlobal = 0;
            }

            sumaTotal = sumaTotal - importeDescuentoGlobal;

            if (sumaIgv !== 0) {
              sumaSubTotal = parseFloat(
                (sumaTotal / divisorCalculoSubTotal).toFixed(2)
              );
              sumaIgv = sumaTotal - sumaSubTotal;
              sumaTotalDetalle = sumaSubTotal;
            } else {
              sumaSubTotal = sumaTotal;
              sumaIgv = 0;
              sumaTotalDetalle = sumaSubTotal;
            }
          } else {
            if (importeDescuentoGlobal > sumaSubTotal) {
              importeDescuentoGlobal = 0;
              porcentajeDescuentoGlobal = 0;
            }

            sumaSubTotal = sumaSubTotal - importeDescuentoGlobal;

            if (sumaIgv !== 0) {
              sumaIgv = parseFloat(
                (sumaIgv !== 0
                  ? sumaSubTotal * (porcentajeIGV / 100)
                  : 0
                ).toFixed(2)
              );
              sumaTotal = parseFloat((sumaSubTotal + sumaIgv).toFixed(2));
            } else {
              sumaTotal = sumaSubTotal;
              sumaSubTotal = sumaSubTotal;
              sumaIgv = 0;
              sumaTotalDetalle = sumaSubTotal;
            }
          }
        }
      }



    }

    /*********** Calculo de Totales 2 ********/

    /*********** Calculo Percepcion ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    //var porcentajePercepcion = 2;
    var porcentajePercepcion = this.props.form.getFieldValue("porcentajePercepcion");

    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    /*********** Calculo Detracion ********/
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");
    var porcentajeDetraccion = this.props.form.getFieldValue("porcentajeDetraccion");

    var codigoMoneda = this.props.form.getFieldValue("codigoMoneda");
    var nroDecimal = codigoMoneda == 'PEN' ? 0 : 2;
    debugger
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    importeDetraccion = parseFloat(importeDetraccion.toFixed(parseInt(nroDecimal)));
    var totalDetraccion = parseFloat(sumaTotal - importeDetraccion);

    /*********** Calculo Retencion ********/
    var flagRetencion = this.props.form.getFieldValue("flagRetencion");
    var porcentajeRetencion = this.props.form.getFieldValue("porcentajeRetencion");
    var importeRetencion = sumaTotal * (porcentajeRetencion / 100);
    var totalRetencion = sumaTotal - importeRetencion;

    this.props.form.setFieldsValue({
      // sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      sumaExonerada: fetchSumaTotalExonerado,
      sumaInafecta: sumaTotalInafecto,
      sumaGratuita: fetchSumaTotalGratuito,

      detalleProductos: detalleProductosFilter,
      [`arrFlagAfecto[${row.identifier}]`]: flagAfecto,
      [`arrFlagExonerado[${row.identifier}]`]: flagExonerado,
      [`arrFlagGratuito[${row.identifier}]`]: flagGratuito,
      [`arrFechaVencimiento[${row.identifier}]`]: fechaVencimiento,

      [`arrFlagISC[${row.identifier}]`]: flagISC,
      [`arrIsc[${row.identifier}]`]: cantidad === 0 ? 0 : importeISC,
      [`arrValorUnitario[${row.identifier}]`]: valorUnitario.toFixed(5),
      [`arrPrecioUnitario[${row.identifier}]`]: precioUnitario.toFixed(5),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(3),
      [`arrTotalDetalle[${row.identifier}]`]: totalDetalle.toFixed(2),
      [`arrPorcentajeDescuento[${row.identifier}]`]: porcentajeDescuento.toFixed(2),
      [`arrImporteDescuento[${row.identifier}]`]: importeDescuento.toFixed(2),
      [`arrSubTotal[${row.identifier}]`]: subTotal.toFixed(2),
      [`arrIgv[${row.identifier}]`]: igv.toFixed(2),
      [`arrTotal[${row.identifier}]`]: total.toFixed(2),
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      importeRetencion: flagRetencion ? importeRetencion : 0,
      totalRetencion: flagRetencion ? totalRetencion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    setTimeout(() => { this.handleCalculateMetodoPago(sumaTotal) }, 500)

  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };



  fetchSumaTotalAfecto = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 10 o 17
      var esGravado = ["10", "17"].includes(codigo);

      if (esGravado) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalInafecto = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 30
      const esInafecto = ["30"].includes(codigo);


      if (esInafecto) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalExonerado = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 20
      const esExonerado = ["20"].includes(codigo);

      if (esExonerado) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalGratuito = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 20
      const esGratuito = !["10", "20", "30", "40", "17"].includes(codigo);

      if (esGratuito) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };

  fetchSumaTotalExportacion = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 40
      const esGratuito = ["40"].includes(codigo);

      if (esGratuito) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };

  fetchReferencias = (values) => {
    var result = [];
    // 
    var flagReferencia = this.props.form.getFieldValue("flagReferencia");
    if (!flagReferencia) {
      this.props.formValues.listaCompraReferencia.forEach((item) => {
        result.push({
          idTipoComprobante: item.idTipoComprobante,
          flagInterno: item.flagInterno,
          idReferenciaOrigen: item.idReferenciaOrigen,
          idReferencia: item.idReferencia,
          serie: item.serie,
          documento: item.documento
        });
      });
      return result;
    }

    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined ||
      values.arrIdReferencia === undefined ||
      values.arrIdReferenciaOrigen === undefined ||
      values.arrFlagInterno === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };


  fetchCuotas = (values) => {
    var result = [];
    if (values.idTipoComprobante != BOLETA_DE_VENTA.ID) {

      var keys = [];
      var obj = Object.assign({}, values.arrVencimiento);

      for (var [key] of Object.entries(obj)) {
        keys.push(key);
      }
      keys.forEach((key) => {
        result.push({
          fechaVencimientoStr:
            values.arrVencimiento[key].format("DD/MM/YYYY"),
          correlativo: parseFloat(values.arrCorrelativo[key]),
          montoCuota: parseFloat(values.arrMontoCuota[key]),
        });
      });
    }

    return result;
  };

  //#region  [MEDIO DE PAGO]

  fetchMetodoPago = (values) => {
    var result = [];
    var flagMetodoPago = this.props.form.getFieldValue("flagMetodoPago");
    if (!flagMetodoPago) {
      this.props.formValues.listaComprobanteMetodoPago.forEach((item) => {
        result.push({
          fechaPagoStr: item.fechaPago,
          idMetodoPago: item.idMetodoPago,
          idCuenta: item.idCuenta,
          referencia: item.referencia,
          montoPago: item.montoPago,
        });
      });
      return result;
    }

    if (
      values.arrFechaPago === undefined ||
      values.arrMontoPago === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrFechaPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        fechaPagoStr:
          values.arrFechaPago[key].format("DD/MM/YYYY"),
        idMetodoPago: values.arrIdTipoMetodoPago[key].key,
        idCuenta: values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key,
        referencia: values.arrReferenciaPago[key],
        montoPago: parseFloat(values.arrMontoPago[key]),
      });
    });


    return result;
  };

  handleChangeTotals = (property, value) => {

    if (property === "flagPercepcion" && value) {
      var porcentajePercepcion = 0;// parseFloat( auth.user() .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0].valor);
      var importePercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) *
        (porcentajePercepcion / 100);
      var totalPercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion;

      this.props.form.setFieldsValue({
        porcentajePercepcion,
        importePercepcion,
        totalPercepcion,
        flagDetraccion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        idDetraccion: undefined,
        idPercepcion: undefined,

      });
    }

    if (property === "flagDetraccion" && value) {
      this.props.form.setFieldsValue(
        {
          flagPercepcion: false,
          flagRetencion: false,

        },
        () => {
          this.props.form.validateFields(["idDetraccion"], { force: true });
        }
      );
    }

    if (property === "flagRetencion" && value) {

      var porcentajeRetencion = this.props.form.getFieldValue("porcentajeRetencion") == 0 ? 3 : 3;
      var importeRetencion = this.fetchFieldValueSum("", "arrTotal", 0) * (porcentajeRetencion / 100);
      var totalRetencion = this.fetchFieldValueSum("", "arrTotal", 0) - importeRetencion;

      this.props.form.setFieldsValue({
        porcentajeRetencion,
        importeRetencion,
        totalRetencion,
        flagDetraccion: false,
        flagPercepcion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        idDetraccion: undefined,
      });
    }


    if (property === "idDetraccion") {
      var importeDetraccion = 0;
      var codigoMoneda = this.props.form.getFieldValue("codigoMoneda");
      var nroDecimal = codigoMoneda == 'PEN' ? 0 : 2;

      var importeDetraccion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100)).toFixed(parseInt(nroDecimal)));
      var totalDetraccion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) - importeDetraccion).toFixed(2));

      this.props.form.setFieldsValue({
        flagPercepcion: false,
        porcentajePercepcion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        porcentajeDetraccion: value,
        importeDetraccion,
        totalDetraccion,

      });
    }

    if (property === "idPercepcion") {
      var importePercepcion = 0;
      var codigoMoneda = this.props.form.getFieldValue("codigoMoneda");
      var nroDecimal = codigoMoneda == 'PEN' ? 0 : 2;

      var importePercepcion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100)));
      var totalPercepcion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion));

      this.props.form.setFieldsValue({
        flagPercepcion: true,
        porcentajePercepcion: value,
        importePercepcion,
        totalPercepcion,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,

      });
    }


    var tipoDocumento = this.props.form.getFieldValue("idTipoComprobante") == undefined ? 0 : this.props.form.getFieldValue("idTipoComprobante").key;

    if (
      [FACTURA.ID, BOLETA_DE_VENTA.ID].includes(tipoDocumento) &&
      (property === "porcentajeDescuentoGlobal" ||
        property === "importeDescuentoGlobal" ||
        property === "flagDescuentoGlobal")) {


      var detalleProductos = this.props.form.getFieldValue("detalleProductos");
      var checkDescuento = false;

      if (property === "flagDescuentoGlobal") {
        if (detalleProductos.length > 0 && value) {

          detalleProductos.forEach(element => {

            if (element.flagAfecto) {
              checkDescuento = true;
              return false;
            }


          });

          if (checkDescuento) {
            this.setState({
              flagTributosIguales: value,
            })

            return false;
          } else {
            this.setState({
              flagTributosIguales: false,
            })
            dialog.error('Para aplicar Descuento Global por lo menos un producto debe estar afecto a IGV');

          }
        } else {
          this.setState({
            flagTributosIguales: false,
          })

        }
        if (!value) {
          this.props.form.setFieldsValue({
            importeDescuentoGlobal: 0,
            porcentajeDescuentoGlobal: 0
          });
        }
      }


      /********  PARAMETROS ********/
      var params = auth.user().parametros;
      var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

      var otroImpuesto = this.props.form.getFieldValue("otroImpuesto");
      var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === otroImpuesto?.key)?.value ?? 18;
      /******** VARIABLES ********/
      var totalDetalle = 0;
      var total = this.fetchFieldValueSum("", "arrTotal", 0);
      var subTotal = this.fetchFieldValueSum("", "arrSubTotal", 0);
      var calculoimporteDescuentoGlobal = 0;
      var importeDescuentoGlobal = parseFloat(this.props.form.getFieldValue("importeDescuentoGlobal"));
      var porcentajeDescuentoGlobal = parseFloat(this.props.form.getFieldValue("porcentajeDescuentoGlobal"));
      var igv = parseFloat(this.props.form.getFieldValue("sumaIgv"));
      var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

      if (property === "porcentajeDescuentoGlobal") {
        porcentajeDescuentoGlobal = parseFloat(value);
      } else if (property === "importeDescuentoGlobal") {
        importeDescuentoGlobal = parseFloat(value);
      } else if (property === "flagDescuentoGlobal") {
        importeDescuentoGlobal = parseFloat(0);
        porcentajeDescuentoGlobal = parseFloat(0);
      }

      /******** CALCULOS DESCUENTO ********/
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuentoGlobal = parseFloat(
          (total * (porcentajeDescuentoGlobal / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuentoGlobal = parseFloat(
          (total * (porcentajeDescuentoGlobal / 100)).toFixed(2)
        );
      }

      if (
        porcentajeDescuentoGlobal !== 0 &&
        property === "porcentajeDescuentoGlobal"
      )
        importeDescuentoGlobal = calculoimporteDescuentoGlobal;

      if (importeDescuentoGlobal !== 0 && property === "importeDescuentoGlobal")
        porcentajeDescuentoGlobal = 0;

      /******** CALCULOS TOTALES ********/

      if (flagPrecioIncluyeIGV) {
        if (importeDescuentoGlobal > total || importeDescuentoGlobal === 0) {
          importeDescuentoGlobal = 0.0;
          porcentajeDescuentoGlobal = 0.0;
        }

        total = total - importeDescuentoGlobal;

        if (igv !== 0) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        if (importeDescuentoGlobal > subTotal || importeDescuentoGlobal === 0) {
          importeDescuentoGlobal = 0.0;
          porcentajeDescuentoGlobal = 0.0;
        }
        subTotal = subTotal - importeDescuentoGlobal;
        //total = total - importeDescuentoGlobal;

        if (igv !== 0) {
          igv = parseFloat(
            (igv !== 0 ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }


      /******** SETEAR CALCULOS TOTALES ********/
      this.props.form.setFieldsValue({
        flagDescuentoGlobal: value,
        sumaTotal: total,
        sumaIgv: igv,
        sumaSubTotal: subTotal,
        sumaTotalDetalle: totalDetalle,
        importeDescuentoGlobal: parseFloat(importeDescuentoGlobal.toFixed(2)),
        porcentajeDescuentoGlobal: parseFloat(porcentajeDescuentoGlobal.toFixed(2)),
      });
    }
  };



  handleOk = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {

      if (values.detalleProductos.length == 0) {
        dialog.error("Agrega detalle de Productos !");
        return false;
      }

      if (values.detalleProductos.filter(m => { return m.flagAplicarSerie === true; }).length > 0) {
        values.detalleProductos.forEach(row => {
          if (row.listaCompraDetalleSerie.length === 0 && row.flagAplicarSerie) {
            dialog.warning("Por favor agregue las series para el producto " + row.nombre);
            return false;
          }
        });
      }

      if (this.fetchCuotas(values).length == 0 && values.idFormaPago.key == 2) {
        dialog.warning("Por favor agregue las cuotas para el comprobante a CRÉDITO.");

        return false;
      }


      if (!err) {
        const porcentajeIGV = lst_tipo_impuesto.find(item => item.id === values.otroImpuesto?.key)?.value ?? 18;

        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante.key,
          idProveedor: values.idProveedor.key,
          idEstablecimientoProveedor: values.idEstablecimientoProveedor.key,
          idVendedor: values.idVendedor === undefined ? 0 : values.idVendedor.key,
          idAlmacen: values.idAlmacen === undefined ? 0 : values.idAlmacen.key,
          idMoneda: values.idMoneda.key,
          idFormaPago: values.idFormaPago === undefined ? 1 : values.idFormaPago.key == undefined ? values.idFormaPago : values.idFormaPago.key,
          idEstablecimiento: values.idEstablecimiento.key,
          idDetraccion: values.idDetraccion === undefined ? 0 : values.idDetraccion.key,
          idPercepcion: values.idPercepcion === undefined ? 0 : values.idPercepcion.key,
          porcentajeIGV: porcentajeIGV,
          totalDetraccion:
            values.idDetraccion === undefined ? 0 : values.totalDetraccion,
          idUsuarioRegistro: values.idUsuarioRegistro,
          serie: values.serie.toUpperCase(),
          documento: values.documento,
          porcentajeRetencion: values.porcentajeRetencion,

          idProyecto: values.idProyecto.key == null ? 0 : values.idProyecto.key,
          idTipoAlmacen: values.idTipoAlmacen === undefined ? 0 : values.idTipoAlmacen.key,
          idMotivoNotaCredito: values.idMotivoNotaCredito === undefined ? 0 : values.idMotivoNotaCredito.key,
          idTipoActividad: values.idTipo === undefined ? 0 : values.idTipo.key,
          importeDetraccion: values.importeDetraccion === undefined ? 0 : values.importeDetraccion,
          porcentajeDetraccion: parseFloat(values.porcentajeDetraccion ?? 0),
          porcentajePercepcion: parseFloat(values.porcentajePercepcion ?? 0),
          flagDescuentoGlobal: values.importeDescuentoGlobal > 0 ? true : false,
          importeDescuentoGlobal: parseFloat(values.importeDescuentoGlobal ?? 0),
          porcentajeDescuentoGlobal: parseFloat(values.porcentajeDescuentoGlobal ?? 0),
          fechaDocumentoStr: values.fechaDocumentoStr.format("DD/MM/YYYY"),
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaVencimientoStr: values.fechaVencimientoStr.format("DD/MM/YYYY"),
          diasVencimiento: parseInt(values.diasVencimiento),
          fechaRecepcionStr: values.fechaRecepcionStr.format("DD/MM/YYYY"),
          tipoCambio: parseFloat(values.tipoCambio),
          observacion: values.observacion,
          flagExportacion: values.flagExportacion,
          flagPercepcion: values.flagPercepcion,
          flagRetencion: values.flagRetencion,
          flagDetraccion: values.flagDetraccion,
          idPendiente: values.idPendiente.key,
          idClasificacion: values.idClasificacion.key,
          total: values.sumaTotal,
          listaCompraDetalle: values.detalleProductos,
          listaCompraReferencia: this.fetchReferencias(values),
          listaComprobanteCuota: this.fetchCuotas(values),
          listaComprobanteMetodoPago: this.fetchMetodoPago(values)
        };

        var totalCuotas = parseFloat(data.listaComprobanteCuota.reduce((a, b) => a + (b["montoCuota"] || 0), 0)).toFixed(2);

        if (data.idFormaPago === CREDITO) {
          if (totalCuotas != parseFloat(data.total).toFixed(2) && !data.flagDetraccion && !data.flagRetencion) {
            dialog.warning("El monto total de cuotas, debe ser igual al total del comprobante.");
            return false;
          }

          if (totalCuotas != parseFloat(data.totalDetraccion.toFixed(2)) && data.flagDetraccion) {
            dialog.warning("El monto total de cuotas, debe ser igual al Importe Neto a Pagar.");
            return false;
          }

          /*         if (totalCuotas != parseFloat(data.totalRetencion.toFixed(2)) && data.flagRetencion) {
                    dialog.warning("El monto total de cuotas, debe ser igual al total Retencion.");
                    return false;
                  } */
        }

        // CONTADO PENDIENTE DE PAGO (NO)
        if (data.idFormaPago == 1 && data.listaComprobanteMetodoPago.length === 0 && data.idPendiente.key == 2) {
          dialog.warning("Por favor agregue el método de pago.");
          return false;
        }

        if (data.idFormaPago == 1) {
          data.listaComprobanteCuota = new Array();
        }



        if (data.listaComprobanteCuota.length > 0) {

          var latest = data.listaComprobanteCuota[data.listaComprobanteCuota.length - 1].fechaVencimientoStr;
          if (data.fechaVencimientoStr != latest) {
            dialog.warning("La ultima cuota debe tener la fecha igual que la fecha de vencimiento del documento");
            return false;
          }

        }

        /*          if(!this.validate_fechaMayorQue(data.fechaStr,data.fechaDocumentoStr)){
                  dialog.warning("La fecha de registro debe ser mayor que la fecha de emision");
                 
                  return false;
                } */


        this.props.onSave(data, this.props.form);
      }
    });
  };




  handleRemoverProducto = (row) => {
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });



    // var sumaImporteDescuento = this.fetchFieldValueSum(
    //   row.identifier,
    //   "arrImporteDescuento",
    //   0
    // );
    var sumaIsc = this.fetchFieldValueSum(row.identifier, "arrIsc", 0);
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
    var sumaSubTotal = this.fetchFieldValueSum(
      row.identifier,
      "arrSubTotal",
      0
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      // sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    this.props.onRemoverProducto(row, this.props.form);

    setTimeout(() => { this.handleCalculateMetodoPago(sumaTotal) }, 500)

  };


  handleCalculateMetodoPago = (sumaTotal) => {

    this.props.onCalculateMetodoPago(sumaTotal, this.props.form);
  }

  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    getFieldDecorator("idTipoComprobante", { initialValue: this.props.formValues.idTipoComprobante });

    getFieldDecorator("proveedores", {
      initialValue: this.props.formValues.proveedores.filter((m) => {
        return m.id === this.props.formValues.idProveedor;
      }),
    });


    getFieldDecorator("sumaExonerada", {
      initialValue: this.props.formValues.sumaExonerada,
    });
    getFieldDecorator("sumaInafecta", {
      initialValue: this.props.formValues.sumaInafecta,
    });
    getFieldDecorator("sumaGratuita", {
      initialValue: this.props.formValues.sumaGratuita,
    });

    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaIsc", {
      initialValue: this.props.formValues.sumaIsc,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.detalleProductos,
    });
    getFieldDecorator("porcentajeDetraccion", {
      initialValue: this.props.formValues.porcentajeDetraccion,
    });
    getFieldDecorator("importeDetraccion", {
      initialValue: this.props.formValues.importeDetraccion,
    });
    getFieldDecorator("totalDetraccion", {
      initialValue: this.props.formValues.totalDetraccion,
    });
    getFieldDecorator("porcentajePercepcion", {
      initialValue: this.props.formValues.porcentajePercepcion,
    });
    getFieldDecorator("importePercepcion", {
      initialValue: this.props.formValues.importePercepcion,
    });
    getFieldDecorator("totalPercepcion", {
      initialValue: this.props.formValues.totalPercepcion,
    });

    getFieldDecorator("flagDescuentoGlobal", {
      initialValue: this.props.formValues.flagDescuentoGlobal,
    });

    getFieldDecorator("importeDescuentoGlobal", {
      initialValue: this.props.formValues.importeDescuentoGlobal,
    });
    getFieldDecorator("porcentajeDescuentoGlobal", {
      initialValue: this.props.formValues.porcentajeDescuentoGlobal,
    });
    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });
    getFieldDecorator("importeRetencion", {
      initialValue: this.props.formValues.importeRetencion,
    });

    getFieldDecorator("totalRetencion", {
      initialValue: this.props.formValues.totalRetencion,
    });

    getFieldDecorator("porcentajeRetencion", {
      initialValue: this.props.formValues.porcentajeRetencion,
    });

    getFieldDecorator("idPendiente", {
      initialValue: this.props.formValues.idPendiente,
    });

    getFieldDecorator("flagCuota", {
      initialValue: false,
    });

    getFieldDecorator("flagMetodoPago", {
      initialValue: false,
    });

    getFieldDecorator("flagPrecioIncluyeIGV", {
      initialValue: this.props.formValues.flagPrecioIncluyeIGV,
    });

    getFieldDecorator("idFormaPago", {
      initialValue: this.props.formValues.idFormaPago,
    });

    getFieldDecorator("codigoMoneda", {
      initialValue: this.props.formValues.idMoneda == SOLES ? 'PEN' : 'USD',
    });

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? `Registrar Comprobante Compra`
            : `Modificar Comprobante Compra`
        }
        visible={this.props.visible}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="ok"
            type="primary"
            loading={this.props.formValues.saveLoading}
            onClick={this.handleOk}
          >
            Guardar
          </Button>,
        ]}
        style={{ top: 30 }}
        width="1100px"
      >

        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        }
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                        {
                          required: true,
                          pattern: new RegExp(GREATER_THAN_ZERO),
                          message: "Campo Obligatorio"
                        }
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                        onBlur={(e) =>
                          this.handleCompleteDecimals(
                            "tipoCambio",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("diasVencimiento", {
                      initialValue: this.props.formValues.diasVencimiento,
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_NUMBER),
                          message: "Formato incorrecto",
                        },
                      ],
                    })(
                      <Input
                        style={{ textAlign: "right" }}
                        placeholder="Ingresar días de vencimiento"
                        autoComplete="off"
                        className="first-input"
                        onBlur={(e) =>
                          this.findDaysAndDates(
                            "diasVencimiento",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaVencimientoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaVencimientoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        className="second-input"
                        onChange={(moment, value) =>
                          this.findDaysAndDates("fechaVencimientoStr", value)
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Registro">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaDocumentoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaDocumentoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de recepción"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Proveedor">
                <InputGroup compact>
                  <Form.Item style={{ width: "20%" }}>
                    {getFieldDecorator("documentoProveedor", {
                      initialValue: this.props.formValues.documentoProveedor,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                          whitespace: true,
                        },
                      ],
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.proveedorLoading}
                        onSearch={(value) =>
                          this.props.onBuscarProveedor(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "80%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idProveedor", {
                        initialValue: this.props.formValues.idProveedor
                          ? { key: this.props.formValues.idProveedor }
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ],
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width: `calc(100% - 40px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Proveedor"}
                          optionFilterProp="children"
                          showArrow={false}
                          onSearch={this.handleSearchAutocompleteProveedor}
                          onChange={this.handleChangeAutocompleteProveedor}
                        >
                          {getFieldValue("proveedores").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idProveedor")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idProveedor: undefined,
                              documentoProveedor: "",
                              idEstablecimientoProveedor: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear");
                            }
                          );
                        }}
                      />
                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Recepción">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaRecepcionStr", {
                      initialValue: moment(
                        this.props.formValues.fechaRecepcionStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de recepción"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
          </div>


          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Dirección">
                {getFieldDecorator("idEstablecimientoProveedor", {
                  initialValue: this.props.formValues
                    .idEstablecimientoProveedor
                    ? {
                      key: this.props.formValues
                        .idEstablecimientoProveedor,
                    }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Direccion"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.direcciones.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre + " - " + item.direccion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator("idProyecto", {
                  initialValue: this.props.formValues.idProyecto
                    ? { key: this.props.formValues.idProyecto }
                    : 0,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: this.props.formValues.idMoneda
                    ? { key: this.props.formValues.idMoneda }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue(
                        {
                          idListaPrecio: undefined,
                        },
                        () => {
                          this.props.onChange("idMoneda", option.key);
                        }
                      );
                    }}
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

          </div>


          <div className="row">

            <div className="col-md-4 form-group">
              <Form.Item label="Tipo">
                {getFieldDecorator("idTipo", {
                  initialValue: this.props.formValues.idTipo
                    ? { key: this.props.formValues.idTipo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Tipo"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idTipo",
                        option.key,
                        this.props.form
                      )
                    }
                    }
                  >
                    {this.props.formValues.Tipo.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Clasificación">
                {getFieldDecorator("idClasificacion", {
                  initialValue: this.props.formValues.idClasificacion
                    ? { key: this.props.formValues.idClasificacion }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Clasificacion"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idClasificacion",
                        option.key,
                        this.props.form
                      )
                    }
                    }
                  >
                    {this.props.formValues.clasificacion.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.descripcion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Tipo Comprobante">
                {getFieldDecorator("idTipoComprobante", {
                  initialValue: this.props.formValues.idTipoComprobante
                    ? { key: this.props.formValues.idTipoComprobante }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Tipo de Comprobante"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idTipoComprobante",
                        option.key,
                        this.props.form
                      )
                    }
                    }
                  >
                    {this.props.formValues.tiposComprobante.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>



          </div>

          <div className="row">

            <div className="col-md-4 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: this.props.formValues.idTipoComprobante == 6 ? false : true,
                          message: "Requerido",
                          whitespace: true,
                        },
                        // {
                        //   validator: this.serieCustomValidation,
                        // },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        maxLength={4}
                        disabled={this.props.formValues.idTipoComprobante == 6}
                        style={{ textTransform: "uppercase" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                      rules: [
                        {
                          validator: this.documentoCustomValidation,
                        },
                        {
                          required: true,
                          message: "Requerido",
                          whitespace: true,
                        }
                      ],
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        onBlur={this.completeDocumento}
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange("idEstablecimiento", option.key, this.props.form);
                    }}
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            {this.props.formValues.idTipo == 2 ? (
              <div className="col-md-4 form-group">
                <Form.Item label="Tipo Almacén">
                  {getFieldDecorator("idTipoAlmacen", {
                    initialValue: this.props.formValues.idTipoAlmacen
                      ? { key: this.props.formValues.idTipoAlmacen }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Tipo Almacén"}
                      optionFilterProp="children"
                      loading={this.props.form.almacenLoading}
                      onChange={(option) =>
                        this.props.onChange(
                          "idTipoAlmacen",
                          option.key,
                          this.props.form
                        )
                      }
                    >
                      {this.props.formValues.TipoAlmacen.map((item) => (
                        item.codigo != '000004' ?
                          <Option key={item.id} value={item.id}> {item.nombre}
                          </Option> : null
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>

            ) : null}



            {this.props.formValues.idTipo == 2 ? (

              <div className="col-md-4 form-group">
                <Form.Item label="Almacén">
                  {getFieldDecorator("idAlmacen", {
                    initialValue: this.props.formValues.idAlmacen
                      ? { key: this.props.formValues.idAlmacen }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Almacén"}
                      optionFilterProp="children"
                      loading={this.props.form.almacenLoading}
                      onChange={(option) =>
                        this.props.onChange(
                          "idAlmacen",
                          option.key,
                          this.props.form
                        )
                      }
                    >
                      {this.props.formValues.almacenes.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            ) : null}

            {FACTURA.ID == this.props.formValues.idTipoComprobante ? (
              <div className="col-md-4 form-group">
                <Form.Item label="Forma de Pago">
                  {getFieldDecorator("idFormaPago", {
                    initialValue: this.props.formValues.idFormaPago
                      ? { key: this.props.formValues.idFormaPago }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Forma Pago"}
                      optionFilterProp="children"
                      onChange={(option) =>
                        this.props.onChange(
                          "idFormaPago",
                          option.key,
                          this.props.form
                        )
                      }
                    >
                      {this.props.formValues.formasPago.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            ) : null}

            <div className="col-md-3 form-group" hidden={true}>
              <Form.Item label="Estado de Pago">
                {getFieldDecorator("idPendiente", {
                  initialValue: this.props.formValues.idPendiente
                    ? { key: this.props.formValues.idPendiente }
                    : undefined,
                })(
                  <Select
                    showSearch
                    disabled={this.props.isPendiente}
                    labelInValue
                    placeholder={"Seleccione Estado Pago"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idPendiente", option.key, this.props.form)}

                  >

                    {this.props.formValues.pendientePago.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            {this.props.formValues.idTipoComprobante == NOTA_DE_CREDITO.ID ? (
              <div className="col-md-4 form-group">

                <Form.Item label="Motivo">
                  {getFieldDecorator("idMotivoNotaCredito", {
                    initialValue: this.props.formValues.idMotivoNotaCredito
                      ? { key: this.props.formValues.idMotivoNotaCredito }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      disabled={this.props.isPendiente}
                      labelInValue
                      placeholder={"Seleccione Motivo"}
                      optionFilterProp="children"
                      onChange={(option) => this.props.onChange("idMotivoNotaCredito", option.key, this.props.form)}
                    >
                      {this.props.formValues.Motivos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>

              </div>
            ) : null
            }

            {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante) ? (
              <div className="col-md-4 form-group"  >
                <Form.Item label="IGV">
                  {getFieldDecorator("otroImpuesto", {
                    initialValue: this.props.formValues.otroImpuesto
                      ? { key: this.props.formValues.otroImpuesto }
                      : undefined,
                    rules: [
                      {
                        required: false,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"IGV"}
                      optionFilterProp="children"
                      onChange={(option) => this.props.onChange("otroImpuesto", option.key, this.props.form)}
                    >
                      {this.props.formValues.Tipoimpuesto.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            ) : null}



          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator('observacion', {
                  initialValue: this.props.formValues.observacion
                })(
                  <TextArea
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">

                    {this.props.formValues.idTipo == 1 ? (
                      <Button
                        icon="plus"
                        type="primary"
                        onClick={() =>
                          this.props.onAgregarItem(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Item Libre
                      </Button>

                    ) : null}

                    <Button
                      icon="plus"
                      type="primary"
                      disabled={this.props.formValues.idTipoComprobante == 10}
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>

                    {NOTA_DE_CREDITO.ID == this.props.formValues.idTipoComprobante ? (
                      <Button
                        icon="import"
                        type="primary"
                        onClick={() =>
                          this.props.onImportarCompra(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Importar Compra
                      </Button>

                    ) : null}

                    {this.props.formValues.idTipo == 2 ? (
                      <Button
                        icon="import"
                        type="primary"
                        disabled={this.props.formValues.idTipoComprobante == 0 || this.props.formValues.idTipoComprobante == undefined}
                        onClick={() =>
                          this.props.onImportarOrdenCompra(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Importar O/C
                      </Button>

                    ) : null}

                    {this.props.formValues.idTipo == 1 ? (
                      <Button
                        icon="import"
                        type="primary"
                        onClick={() =>
                          this.props.onImportarOrdenCompra(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Importar O/S
                      </Button>

                    ) : null}

                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Productos y Servicios
                    </span>
                  }
                  key="1"
                >
                  <Productos
                    dataSource={this.props.formValues.listaCompraDetalle}
                    onRemove={this.handleRemoverProducto}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onAgregarSerie={this.props.onAgregarSerie}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                    tipoAfectacion={this.props.formValues.tipoAfectacion}

                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Referencias
                    </span>
                  }
                  key="2"
                >
                  <Referencias
                    dataSource={
                      this.props.formValues.listaCompraReferencia
                    }
                    tiposComprobante={this.props.formValues.tiposComprobanteAll}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>

                {this.props.formValues.idFormaPago == 2 ? (
                  <TabPane
                    visible={false}
                    tab={
                      <span>
                        <Icon type="unordered-list" /> Detalle de Cuotas
                      </span>
                    }
                    key="3"
                  >
                    <Cuotas

                      dataSource={this.props.formValues.listaComprobanteCuota}
                      onRemove={this.props.onRemoverCuota}
                      onGetFieldDecorator={getFieldDecorator}
                    />
                  </TabPane>
                ) : null}
                {this.props.formValues.idFormaPago == 1 && this.props.formValues.idPendiente == 2 ? (
                  <TabPane

                    tab={
                      <span>
                        <Icon type="unordered-list" /> Método de Pago
                      </span>
                    }
                    key="4"
                  >
                    <MetodoPago

                      dataSource={this.props.formValues.listaComprobanteMetodoPago}
                      metodosPagos={this.props.formValues.metodosPagos}
                      listaBancos={this.props.formValues.listaBanco}
                      onChangePago={this.props.onChangePago}
                      cuentas={this.props.formValues.cuentas}
                      onRemove={this.props.onRemoverMetodoPago}
                      onGetFieldDecorator={getFieldDecorator}
                    />
                  </TabPane>
                ) : null}
              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onChangeTotals={this.handleChangeTotals}
            onGetFieldDecorator={getFieldDecorator}
            onGetFieldValue={getFieldValue}
            onSetFieldsValue={setFieldsValue}
          />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormModal);